import * as RouteUtils from 'routes/route_utils.jsx';

export default {
    path: 'billing',
    getComponents: (location, callback) => {
        // System.import('components/checkout/checkout_controller.jsx').then(RouteUtils.importComponentSuccess(callback));
        System.import('components/checkout/checkout_controller.jsx').then(RouteUtils.importComponentSuccess(callback));
    },
    indexRoute: {
        getComponents: (location, callback) => {
            System.import('components/checkout/components/billing_overview.jsx').then(RouteUtils.importComponentSuccess(callback));
        }
    },
    // indexRoute: {onEnter: (nextState, replace) => replace('/create_team/display_name')},
    getChildRoutes: RouteUtils.createGetChildComponentsFunction(
        [
            {
                path: 'address',
                getComponents: (location, callback) => {
                    System.import('components/checkout/components/address.jsx').then(RouteUtils.importComponentSuccess(callback));
                }
            },
            {
                path: 'checkout',
                getComponents: (location, callback) => {
                    System.import('components/checkout/components/checkout.jsx').then(RouteUtils.importComponentSuccess(callback));
                }
            }

            // ,
            // {
            //     path: 'team_url',
            //     getComponents: (location, callback) => {
            //         System.import('components/create_team/components/team_url.jsx').then(RouteUtils.importComponentSuccess(callback));
            //     }
            // }
        ]
    )
};



// WEBPACK FOOTER //
// ./routes/route_checkout.jsx